import React from "react";
import { IButtonProps } from "../../../@interfaces";
import Text from "../../text";

const LoginButton: React.FC<IButtonProps> = ({
  children,
  loading,
  loadingColor,
  className,
  ...props
}) => {
  return (
    <button
      {...props}
      disabled={loading}
      className={` w-full font-[400] px-[10px] py-[8px] rounded-[4px] transition-all flex items-center justify-center border-none
        ${loading ? "bg-[#f3f4f6] cursor-not-allowed" : "bg-[#4ea5f3] cursor-pointer hover:bg-[#358fdd]"
        }
        text-[#eef6ff] text-[16px]
        ${className || ""}
      `}
    >
      {!loading ? (
        children
      ) : (
        <Text className="!text-[1rem] !text-[#d2d6dd]">AGUARDE...</Text>
      )}
    </button>
  );
};

export default LoginButton;
